module.exports = __webpack_public_path__ + "static/media/lowerRisk.8cb62ace.mp3";